import {
	DeprecatedConnectedColorIndicator as ConnectedColorIndicator,
	DeprecatedFlexItem as FlexItem,
} from '@forecast-it/design-system';
import React from 'react';
import HeaderColumnContainer from './HeaderColumnContainer';
import ProjectPrefixFlexItem from './ProjectPrefixFlexItem';
import NoShrinkFlexItem from './NoShrinkFlexItem';
import {hasFeatureFlag} from '../../../../forecast-app/shared/util/FeatureUtil';
import {ProjectIndicator} from 'web-components';
import {Link} from 'react-router-dom';

const ConnectedProjectHeaderColumn = ({projectGroup}) => {
	const readOnlyAccess = projectGroup.readOnlyAccess;
	return (
		<HeaderColumnContainer>
			<NoShrinkFlexItem flexBasis={'28px'}>
				{hasFeatureFlag('resource_program_management_v1') ? (
					readOnlyAccess ? (
						<ConnectedColorIndicator size={'s'} color={projectGroup.color} />
					) : (
						<Link to={`/connected/X-${projectGroup.companyProjectGroupId}`}>
							<ConnectedColorIndicator size={'s'} color={projectGroup.color} />
						</Link>
					)
				) : (
					<ProjectIndicator
						isConnectedProject={true}
						name={projectGroup.name}
						id={projectGroup.companyProjectGroupId}
						color={projectGroup.color}
					/>
				)}
			</NoShrinkFlexItem>
			{hasFeatureFlag('resource_program_management_v1') ? (
				<ProjectPrefixFlexItem>X{projectGroup.companyProjectGroupId}</ProjectPrefixFlexItem>
			) : null}
			<FlexItem>{projectGroup.name}</FlexItem>
		</HeaderColumnContainer>
	);
};

export default ConnectedProjectHeaderColumn;
